import styled, { css, keyframes } from "styled-components";

const warning = keyframes`
0% {
  transform: scale(1);
}
5% {
    transform: scale(1.1);
}
10% {
    transform: scale(0.95);
}
15% {
    transform: scale(1.1);
}
20% {
    transform: scale(0.95);
}
25% {
    transform: scale(1.1);
}
30% {
    transform: scale(0.95);
}
35% {
    transform: scale(1.1);
}
40% {
    transform: scale(0.95);
}
45% {
    transform: scale(1.1);
}
50% {
    transform: scale(0.95);
}
55% {
    transform: scale(1.1);
}
60% {
    transform: scale(0.95);
}
65% {
    transform: scale(1.1);
}
70% {
    transform: scale(0.95);
}
75% {
    transform: scale(1.1);
}
80% {
    transform: scale(0.95);
}
85% {
    transform: scale(1.1);
}
90% {
    transform: scale(0.95);
}
95% {
    transform: scale(1.1);
}
98% {
    transform: scale(0.95);
}
100% {
    transform: scale(1.1);
}
`;
const Countdowner = styled.div<{ timeLeft: number }>`
  transition: color 1s;
  color: var(--color-field-point-0);
  ${({ timeLeft }) => {
    if (timeLeft <= 10) {
      return css`
        animation: ${warning} 10s linear;
      `;
    }
    if (timeLeft <= 20) {
      return ``;
    } else {
      return `color: inherit;`;
    }
  }}
  animation-delay: 0.5s;
  position: absolute;
  bottom: 0px;
  right: 0;
`;
export default Countdowner;
